module.exports = __webpack_public_path__ + "img/kachel-zeitgard_ZEITGARD-CARESYSTEM.815e7fa9.png";